export default function categoryPairs (categories) {
  const result = []
  // Makes the pairs and pushes them in 'result' array
  while (categories.length) {
    const dog = categories.splice(0, 1)
    const dog2 = categories.splice(0, 1)

    result.push([...dog, ...dog2])
  }
  return result
}
